import { render, staticRenderFns } from "./DeclaredSuccess.vue?vue&type=template&id=58f8d12c&scoped=true&"
import script from "./DeclaredSuccess.vue?vue&type=script&lang=js&"
export * from "./DeclaredSuccess.vue?vue&type=script&lang=js&"
import style0 from "./DeclaredSuccess.vue?vue&type=style&index=0&id=58f8d12c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f8d12c",
  null
  
)

export default component.exports